const getSelectedVariant = (form, product) => {
  if (!form || !product) return null;
  const idField = form.querySelector('input[name="id"]');
  const submit = form.querySelector('[type="submit"]');
  if (!idField || !submit) return;

  const selectedValues = [];
  form.querySelectorAll('[product-option] input[type="radio"]:checked').forEach(option => {
    selectedValues.push({
      value: option.value,
      index: option.name
    });
  });

  const variant = product.variants.find(variant => {
    return selectedValues.every(value => {
      return variant[value.index] == value.value;
    });
  });

  if (variant) {
    idField.value = variant.id;
    submit.disabled = !variant.available;
  } else {
    idField.value = '';
    submit.disabled = true;
  }

  return variant;
};

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (tile) => {
  if (!tile) return;

  const tileHover = tile.querySelector('.product-tile__hover');
  if (tileHover) {
    if (tileHover.classList.contains('product-tile__hover--color')) {
      const $dots = $(tile).find('.product-tile__hover--color__dot:not([selected])');
      if ($dots.length > 0) {
        $dots.each(function () {
          $(this).on('mouseenter', function () {
            if ($(window).width() <= 768) return;

            const $colorNames = $(this).closest('.product-tile__hover--color').find('.product-tile__hover--color__name[data-color-name]');
            if ($colorNames.length > 0) {
              $colorNames.css('opacity', '0');
            }

            const $hoveredColor = $(this).closest('.product-tile__hover--color').find('.product-tile__hover--color__name[data-color-name="' + $(this).data('colorName') + '"]');
            if ($hoveredColor.length > 0) {
              $hoveredColor.css('opacity', '1');
            }
          });

          $(this).on('mouseleave', function () {
            if ($(window).width() <= 768) return;

            const $colorNames = $(this).closest('.product-tile__hover--color').find('.product-tile__hover--color__name[data-color-name]');
            if ($colorNames.length > 0) {
              $colorNames.css('opacity', '');
            }
          });
        });
      }
    } else {
      const hoverOpener = tile.querySelector('.product-tile__meta__form-opener');
      if (hoverOpener) {
        hoverOpener.addEventListener('click', () => {
          hoverOpener.classList.toggle('open');
          tileHover.classList.toggle('open');
        });
      }

      const productForm = tileHover.querySelector('.product-tile__hover--quick-buy__form');
      if (!productForm) return;
      const productJsonScript = productForm.querySelector('[product-json]');
      const idField = productForm.querySelector('input[name="id"]');
      if (!idField || !productJsonScript || !productJsonScript.innerHTML.trim()) return;
      const product = JSON.parse(productJsonScript.innerHTML.trim());
      getSelectedVariant(productForm, product);

      productForm.addEventListener('change', () => {
        getSelectedVariant(productForm, product);
      });

      productForm.addEventListener('submit', e => {
        e.preventDefault();
        if (typeof (ShopifyAPI) !== 'undefined' && typeof (ShopifyAPI.addItemFromForm) !== 'undefined') {
          ShopifyAPI.addItemFromForm(
            productForm,
            () => {
              productForm.querySelectorAll('.product-tile__hover--quick-buy__form__option > label.open').forEach(openFieldset => {
                openFieldset.classList.remove('open');
              });

              if (typeof (theme.settings.cartType) === 'undefined' || theme.settings.cartType === 'drawer') {
                if (typeof (ShopifyAPI.getCart) !== 'undefined') {
                  ShopifyAPI.getCart(() => {
                    if (typeof (ajaxCart) !== 'undefined' && typeof (ajaxCart.load) !== 'undefined') {
                      ajaxCart.load();
                    }
                  });
                }
              } else {
                ajaxCart.load();
              }
            }
          );
        } else {
          productForm.submit();
        }
      });

      productForm.querySelectorAll('.product-tile__hover--quick-buy__form__option > label').forEach(fieldsetOpener => {
        fieldsetOpener.addEventListener('click', () => {
          if (fieldsetOpener.classList.contains('open')) {
            fieldsetOpener.classList.remove('open');
          } else {
            productForm.querySelectorAll('.product-tile__hover--quick-buy__form__option > label.open').forEach(openFieldset => {
              openFieldset.classList.remove('open');
            });
            fieldsetOpener.classList.add('open');
          }
        });
      });
    }
  }
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
    window.dAgency.initProductTile(tile);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
      window.dAgency.initProductTile(tile);
    });
  });
}
